
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404X4L74l1rfF85hNn9i_epk1TyErklN0JVaZT1yJlcI44Meta } from "/app/apps/cue-subclient/pages/404.vue?macro=true";
import { default as indexA3sSlkd56fFosMTDhZ9jKJB2XK5tQi9f2lT7jjO6aa4Meta } from "/app/apps/cue-subclient/pages/index.vue?macro=true";
import { default as staff2qU_45matxfDkEJRh2cRdI_YC7lyOcI3z3QhddcEegqFgMeta } from "/app/apps/cue-subclient/pages/staff.vue?macro=true";
import { default as _91id_93yd6pJGyKL6c0P4AjyjaDas9oucGcLsSRh_QCdgZySeUMeta } from "/app/apps/cue-subclient/pages/services/[id].vue?macro=true";
import { default as indexFgA3NzgdTePzi5aUOwwM9WEA0ksr9nEjS7h8fZs3A_AMeta } from "/app/apps/cue-subclient/pages/services/index.vue?macro=true";
import { default as badqoHpegaojRN21rJXYEKWaEVrJ2zr_458ZaTf3N2d2qY4UMeta } from "/app/apps/cue-subclient/pages/orders/[id]/bad.vue?macro=true";
import { default as _91oid_93aiYA7tZTjHtOGe85OFtv2FtLcT5anXihNDzmVIzc5s0Meta } from "/app/apps/cue-subclient/pages/booking/[id]/[oid].vue?macro=true";
import { default as indexix_45nifIWK6YCzUVuMaPNuAomHx_lADzlIatDGsO3U7cMeta } from "/app/apps/cue-subclient/pages/booking/[id]/index.vue?macro=true";
import { default as orderei1OKm5pMjIr_45igEqVDHSk_45_BdCJMJBrpEyewn9quREMeta } from "/app/apps/cue-subclient/pages/booking/[id]/order.vue?macro=true";
import { default as targetSM_rNj9L9cugg8DNlIw57sN7_45z9fQoD8d7LKOK4isn8Meta } from "/app/apps/cue-subclient/pages/booking/[id]/target.vue?macro=true";
import { default as successWacKvM3VgE9YSP7_45rxhnZJfuVHAbL7dLAcp80AHKXNwMeta } from "/app/apps/cue-subclient/pages/orders/[id]/success.vue?macro=true";
import { default as detailsMNmYqaDSjFOqOGvBL9tuREHqoyvASgdCG9io_xNyC78Meta } from "/app/apps/cue-subclient/pages/booking/[id]/details.vue?macro=true";
import { default as component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4ToMeta } from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_db0@0.3.1_eslint@9.23.0_jiti@2.4._164c448f6780f58309225d1b4fa91c34/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4To } from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_db0@0.3.1_eslint@9.23.0_jiti@2.4._164c448f6780f58309225d1b4fa91c34/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/app/apps/cue-subclient/pages/404.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/cue-subclient/pages/index.vue")
  },
  {
    name: "staff",
    path: "/staff",
    component: () => import("/app/apps/cue-subclient/pages/staff.vue")
  },
  {
    name: "services-id",
    path: "/services/:id()",
    meta: _91id_93yd6pJGyKL6c0P4AjyjaDas9oucGcLsSRh_QCdgZySeUMeta || {},
    component: () => import("/app/apps/cue-subclient/pages/services/[id].vue")
  },
  {
    name: "services",
    path: "/services",
    meta: indexFgA3NzgdTePzi5aUOwwM9WEA0ksr9nEjS7h8fZs3A_AMeta || {},
    component: () => import("/app/apps/cue-subclient/pages/services/index.vue")
  },
  {
    name: "orders-id-bad",
    path: "/orders/:id()/bad",
    component: () => import("/app/apps/cue-subclient/pages/orders/[id]/bad.vue")
  },
  {
    name: "booking-id-oid",
    path: "/booking/:id()/:oid()",
    component: () => import("/app/apps/cue-subclient/pages/booking/[id]/[oid].vue")
  },
  {
    name: "booking-id",
    path: "/booking/:id()",
    meta: indexix_45nifIWK6YCzUVuMaPNuAomHx_lADzlIatDGsO3U7cMeta || {},
    component: () => import("/app/apps/cue-subclient/pages/booking/[id]/index.vue")
  },
  {
    name: "booking-id-order",
    path: "/booking/:id()/order",
    component: () => import("/app/apps/cue-subclient/pages/booking/[id]/order.vue")
  },
  {
    name: "booking-id-target",
    path: "/booking/:id()/target",
    component: () => import("/app/apps/cue-subclient/pages/booking/[id]/target.vue")
  },
  {
    name: "orders-id-success",
    path: "/orders/:id()/success",
    component: () => import("/app/apps/cue-subclient/pages/orders/[id]/success.vue")
  },
  {
    name: "booking-id-details",
    path: "/booking/:id()/details",
    component: () => import("/app/apps/cue-subclient/pages/booking/[id]/details.vue")
  },
  {
    name: component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4ToMeta?.name,
    path: "/nav",
    component: component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4To
  },
  {
    name: component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4ToMeta?.name,
    path: "/services/info/:pathMatch(.*)",
    component: component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4To
  },
  {
    name: component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4ToMeta?.name,
    path: "/booking",
    component: component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4To
  },
  {
    name: component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4ToMeta?.name,
    path: "/booking/:pathMatch(.*)/order",
    component: component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4To
  },
  {
    name: component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4ToMeta?.name,
    path: "/booking/:pathMatch(.*)/details",
    component: component_45stub0c2PN_455r3T99pZ6AW0PkXrEaIWbDABE9Uaocxdyd4To
  }
]